export default __webpack_public_path__ + "static/bgVUfOQJ-14fa0de0b1375454b55cb87cf1779bd7.svg";